import React from 'react'
import User from 'routes/Board/User'
import ActivityGroup from 'components/ActivityGroup'
import ActivityContent from './ActivityContent'

const Activity = ({ ...props }) => {
  return (
    <ActivityGroup
      {...props}
      userComponent={User}
      contentComponent={ActivityContent}
    />
  )
}

export default Activity
